import React, { FC, useMemo } from 'react'
import { JCMSCTA, JCMSCTAProps } from './../JCMSCTA'
import { CMSSection } from './../models/CMSConfig'
import './JCMSCTAContainer.scss'
export interface JCMSCTAContainerProps extends CMSSection {
    cta: JCMSCTAProps[],
    align?: 'left' | 'right' | 'center'
}

export const JCMSCTAContainer: FC<JCMSCTAContainerProps> = props => {
    const align = useMemo(() => props.align || 'left', [])
    return (
        <div className={`jcmscta-container jcmscta-container-align-${align}`}>
            {
                props.cta.map((cta, i) => (
                    <JCMSCTA key={i} {...cta} />
                ))
            }
        </div>
    )
}